import { assertExists } from '../assertions'

/**
 * Returns:
 * - A promise (that will never complete on its own)
 * - A `complete` function, that you can call to resolve the promise successfully
 * - A `reject` function, that you can call to reject the promise
 */
export const externallyCompletablePromise = <T>(): {
  promise: Promise<T>
  complete: (value: T) => void
  reject: (error: Error) => void
} => {
  let complete: ((value: T) => void) | undefined = undefined
  let reject: ((error: Error) => void) | undefined = undefined
  const promise = new Promise<T>((onFulfilled, onRejected) => {
    complete = onFulfilled
    reject = onRejected
  })
  return {
    promise,
    complete: assertExists(complete) as unknown as (value: T) => void,
    reject: assertExists(reject) as unknown as (error: Error) => void,
  }
}
